export default __webpack_public_path__ + "static/media/ng.1b00f0e4.svg";